import type {Workload} from "../../3-workload-analysis/model/Workload.ts";

/**
 * Get all unique sources for a workload's task executions
 */
export function getWorkloadSources(workload: Workload): string {
    const sources = new Set<string>()
    workload.tasks.forEach(task => {
        sources.add(task.batchInfo.source)
    })
    return Array.from(sources).join(', ')
}
